import type { Address } from "~/types/address";

const STORAGE_KEY = "user_recent_locations";
const MAX_RECENT = 5;

export const getRecentAddresses = (): Address[] => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};

export const addRecentAddress = (data: Address): Address[] => {
  const existing = getRecentAddresses();

  const filtered = existing.filter(
    (item) =>
      !(
        (
          item.gps?.latitude === data.gps?.latitude &&
          item.gps?.longitude === data.gps?.longitude
        ) ||
        item.formatted_address === data.formatted_address
      )
  );

  const updated = [data, ...filtered].slice(0, MAX_RECENT);

  saveRecentAddresses(updated);

  return updated;
};

const saveRecentAddresses = (addresses: Address[]) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(addresses));
  } catch (error) {
    console.error("Error saving location:", error);
  }
};